import {RoomPlannerProductWithTemplate} from 'components/customer/RoomPlanner/types';

export const getCabinetBoundingBox = (
    product: RoomPlannerProductWithTemplate
) => {
    const thickness = product.cabinet_carc_thickness + 2 || 16.5;
    const height = Number(product.cabinet_height) || 900;
    const width = Number(product.cabinet_width) || 600;
    const depth = Number(product.cabinet_depth) + thickness || 600;

    return {height, width, depth, thickness};
};
